import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './AppShell';
import reportWebVitals from './reportWebVitals';
import { initializeLogger } from './logger/logger';

initializeLogger(
  process.env.REACT_APP_USE_CONSOLE === 'true',
  process?.env?.REACT_APP_SHOWN_LOG_LEVELS,
  process.env.REACT_APP_ROBUST_CONSOLE_LOG === 'true'
);

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
